import { TagDto } from '../dto';
import { Tag } from '../model';

export class TagFactory {
  public static createFromDtos(dtos: TagDto[]): Tag[] {
    return dtos.map(dto => this.createFromDto(dto));
  }

  public static createFromDto(dto: TagDto): Tag {
    return this.createTag(dto.id, dto.value, dto.identifier);
  }

  public static createTag(
    id?: string,
    value?: string,
    identifier?: string,
  ): Tag {
    const tag = new Tag();
    tag.id = id;
    tag.value = value;
    tag.identifier = identifier;
    return tag;
  }
}
